import React, { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Header } from '../../components/Complex'
import {
  Empresas,
  CentroEsportivo,
  Settings,
  DetalhesAgendamento,
  Chat,
  Pix,
  HoraFixa,
  AgendaUser,
  Diaria,
  AspectLegal,
  Torneios,
} from '../../components/Pages'
import { AuthContext } from '../../contexts/AuthContext'
import { InputButton, Loading } from '../../components/Simple'
import RouterHook from '../../contexts/RouterHook'
import RequireAuth from '../../contexts/RequireAuth'

export default function Menu() {
  const serverRouter = RouterHook()
  const { sttAuthCtx, loadsAuth } = useContext(AuthContext)

  const exibeTorneio = false

  const rotas_label = {
    pix: '/pagamento/:idpagamento',
    home: '/cidade/:cidadeLabel',
    chat: '/conversas/:idusuario',
    settings: '/configuracoes/:idusuario',
    horaFixa: '/mensalista/:idmensalista',
    detailsApp: '/agendamento/:idpedido',
    homeCompany: '/centro-esportivo/:username',
    userSched: '/minha-agenda',
    diaria: '/diaria/:iddiaria',
    aspectLegal: '/aspectos-legais/:idusuario',
    competicao: '/competicao/:idtorneio',
  }

  return (
    <div className='contain-max-center'>
      {!sttAuthCtx.isMobile && (
        <Header.ContainH>
          {sttAuthCtx.isLogged ? (
            <Header.AuthActions />
          ) : (
            <InputButton
              title='Realizar Login'
              width={'auto'}
              onClick={() => {
                serverRouter('login')
              }}
            >
              Entrar
            </InputButton>
          )}
        </Header.ContainH>
      )}
      <div className='contain-mid-center'>
        {loadsAuth.page ? (
          <div className='contain-loading'>
            <Loading text={'Carregando...'} />
          </div>
        ) : (
          <Routes>
            <Route path={rotas_label.home} element={<Empresas />} />
            <Route path={rotas_label.homeCompany} element={<CentroEsportivo />} />
            {exibeTorneio && <Route path={rotas_label.competicao} element={<Torneios />} />}
            <Route
              path={rotas_label.horaFixa}
              element={<RequireAuth>{<HoraFixa />}</RequireAuth>}
            />
            <Route
              path={rotas_label.userSched}
              element={<RequireAuth>{<AgendaUser />}</RequireAuth>}
            />
            <Route path={rotas_label.diaria} element={<RequireAuth>{<Diaria />}</RequireAuth>} />
            <Route
              path={rotas_label.aspectLegal}
              element={<RequireAuth>{<AspectLegal />}</RequireAuth>}
            />
            <Route
              path={rotas_label.settings}
              element={
                <RequireAuth>
                  <Settings />
                </RequireAuth>
              }
            />
            <Route
              path={rotas_label.detailsApp}
              element={
                <RequireAuth>
                  <DetalhesAgendamento />
                </RequireAuth>
              }
            />
            <Route
              path={rotas_label.chat}
              element={
                <RequireAuth>
                  <Chat />
                </RequireAuth>
              }
            />
            <Route
              path={rotas_label.pix}
              element={
                <RequireAuth>
                  <Pix />
                </RequireAuth>
              }
            />
          </Routes>
        )}
        {/* {<BttNewApp />} */}
      </div>
    </div>
  )
}
